import React from 'react';
import './StudentExerciseProtection.css';

function StudentExerciseProtection({ children }) {
  return <>{children}</>;
}

export default StudentExerciseProtection;
